import { makeStateKey } from "@angular/core";
import { HandledHttpResponse } from "@uzenith360/http-utils";
import EventUserCode from "../event-user-code.interface";

export default makeStateKey<HandledHttpResponse<Omit<EventUserCode, 'downloadPIN'> & { downloadPIN: boolean }>>('gallery-data');